
import React, { Fragment, useContext } from 'react';
import { Maximize } from 'react-feather';
import { LI, UL } from '../../../AbstractElements';
import UserOptions from './UserOptions';
import MoonLight from './MoonLight';
import { ButtonBuilder } from '../../../GlobalComponents/Builders';
import { AccountContext } from '../../../GlobalComponents/Authentication/Accounts';

const Rightbar = () => {

    const { userSession, exitPartnerPortal } = useContext(AccountContext);

    //full screen function
    function goFull() {
        if ((document.fullScreenElement && document.fullScreenElement !== null) ||
            (!document.mozFullScreen && !document.webkitIsFullScreen)) {
            if (document.documentElement.requestFullScreen) {
                document.documentElement.requestFullScreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullScreen) {
                document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    }

    return (
        <Fragment>
            <div className="nav-right col pull-right right-menu p-0">
                <UL attrUL={{ className: `simple-list d-flex flex-row nav-menus` }} >
                    <LI>
                        { userSession['custom:emulationActive'] === 'true' ?
                            <ButtonBuilder onClick={() => exitPartnerPortal() }
                                label={'Exit ' + (userSession['custom:clientId'] === '0' ? 'Partner' : 'Client') + ' Portal'} />
                        : null }
                    </LI>
                    {/* Full-screen is desktop-only; hidden on mobile to save space */}
                    <LI attrLI={{ onClick: goFull, style: { cursor: 'pointer' }, className: 'd-none d-lg-block' }}>
                        <a className="text-dark" href="#javascript">
                            <Maximize />
                        </a>
                    </LI>
                    {/*<LanguageClass />*/}
                    {/*<Bookmarks />*/}
                    {/*<Notifications />*/}
                    <MoonLight />
                    {/* <MessageDrop /> */}
                    <UserOptions />
                </UL>
            </div>
        </Fragment >
    );
};

export default Rightbar;